// IVR / call-routing calls are stored as inbound; these helpers label them properly.
export const isIvrCall = (c) => !!c && (c.call_type === 'ivr' || !!c.routing_flow_id || !!c.ivr_routed_to);

export const callKindLabel = (c, short = false) => {
  if (isIvrCall(c)) return short ? 'IVR' : 'IVR / Call Routing';
  if (c?.direction === 'inbound') return short ? 'IN' : 'Inbound';
  return short ? 'OUT' : 'Outbound';
};
